// Imports ------------------------------------------------------------------->

import { Coupon } from '../definitions/CouponDefinitions'

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export function isHeroCoupon(coupon: Coupon) {
    const matchup = coupon.matchUps.length > 0 ? coupon.matchUps[0] : null
    return (
        matchup &&
        coupon.dollarsOff !== null &&
        matchup.finalPrice !== null &&
        matchup.percentOff !== null &&
        matchup.displayFinalPrice === true
    )
}

export function compareCoupon(a: Coupon, b: Coupon) {
    if (a.matchUps.length > 0 && b.matchUps.length === 0) return -1
    if (b.matchUps.length > 0 && a.matchUps.length === 0) return 1

    if (a.priority !== b.priority) {
        return a.priority - b.priority
    }

    //
    if (a.matchUps.length > 0 && b.matchUps.length > 0) {
        const aMatch = a.matchUps[0],
            bMatch = b.matchUps[0]
        if (aMatch.percentOff !== null && bMatch.percentOff === null) return -1
        if (bMatch.percentOff !== null && aMatch.percentOff === null) return 1
        if (aMatch.percentOff !== bMatch.percentOff) {
            return bMatch.percentOff - aMatch.percentOff
        }
    }

    const aFrom = a.availableFrom.getTime()
    const bFrom = b.availableFrom.getTime()
    if (aFrom !== bFrom) {
        return bFrom - aFrom
    }

    return b.id - a.id
}

export function breakLines(
    str: string,
    charsPerLine: number,
    maxLines: number
) {
    const words = str.split(' ') // process word by word
    const lines: string[] = []
    let line = ''

    for (let i = 0; i < words.length; i++) {
        const word = words[i]

        if (lines.length === maxLines - 1) {
            if (line.length + word.length + 4 > charsPerLine) {
                line += ' ...'
                lines.push(line)
                line = ''
                break
            } else {
                line += ' ' + word
            }
        } else {
            if (line.length + word.length > charsPerLine) {
                lines.push(line)
                line = word
            } else {
                line += ' ' + word
            }
        }
    }

    if (lines.length < maxLines && line !== '') lines.push(line)
    return lines
}
